module.exports = __webpack_public_path__ + "c3f65707e3017eef031312f06b121c6c.svg";